export default __webpack_public_path__ + "static/MartianMono-Medium-c340419ebc1b888ace119c135b0383a3.ttf";